<template>
    <EmployeeStatistics></EmployeeStatistics>
</template>
<script>
    import EmployeeStatistics from '@/components/EmployeeStatistics.vue'
    export default {
        name: 'admin-home',
        components: {
            EmployeeStatistics
        }
    }
</script>